export async function useFetchApps() {
  const { data: apps } = await useFetch<App[]>('/api/apps', {
    baseURL: useRuntimeConfig().public.cms,
    query: {
      populate: 'deep',
    },
    deep: false,
    key: 'dbc-apps',
    transform: (response: any) => {
      return response.data
    },
  })

  return apps
}
